<template>
  <div>
    <header-component></header-component>

    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Job List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="insertJob">Add New</base-button>
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="sortedJobList"
        >
          <el-table-column label="Description" prop="description"></el-table-column>
          <el-table-column min-width="70px" label="Actions">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="delete" style="color: #f56c6c">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="Add Job" :visible.sync="addJob">
        <add-job @close="addJob = false"></add-job>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import AddJob from "./AddJob";
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-job": AddJob,
    "header-component": headerComponent
  },
  data: () => {
    return {
      addJob: false
    };
  },

  computed: {
    ...mapGetters({
      jobList: "job/getJobList",
      getJob: "job/getJob"
    }),
    sortedJobList() {
      return [...(this.jobList || [])].sort((a, b) =>
        (a.description || '').localeCompare(b.description || '')
      );
    }
  },

  mounted() {
    this.getJobList();
  },

  methods: {
    ...mapActions({
      fetchJob: "job/fetchJob",
      getJobList: "job/getJobList"
    }),
    ...mapMutations({
      resetJob: "job/resetJob",
      setJob: "job/setJob"
    }),
    insertJob() {
      this.resetJob();
      this.addJob = true;
    },
    handleAction(job, command) {
      if (command === "edit") {
        this.fetchJob(job.jobId).then(res => {
          this.setJob(res);
          this.addJob = true;
        });
      } else if (command === "delete") {
        if (!window.confirm("Delete this job?")) return;
        new Api().call("delete", `${endpoints.LARAVEL_BASE_URL}/api/v1/jobs/${job.jobId}`)
          .then(() => {
            this.getJobList();
            window.notify && window.notify({ message: "Deleted", type: "success", title: "Success" });
          })
          .catch(() => {
            window.notify && window.notify({ message: "Failed to delete", type: "danger", title: "Error" });
          });
      }
    }
  }
};
</script>